// Nail Outlet — agrega funcionalidad al botón "+ Añadir al carrito" que ya existe
// en las tarjetas de producto (.no-pc-quick, snippets/no-product-card.liquid).
// Ese botón vive dentro de un <a> que envuelve toda la tarjeta y hasta ahora no tenía
// ningún JS enganchado, así que un clic solo navegaba a la ficha del producto (el
// comportamiento por defecto del <a>). Este script no agrega ningún botón nuevo: solo
// conecta el que ya está ahí para que agregue el producto vía AJAX y se quede en la
// misma página, mostrando una confirmación breve en el propio botón (igual que en
// nailpro.cl). La página de carrito sigue siendo la de siempre en /cart.
(function () {
  function updateCartIconBubble(parsedState) {
    if (!parsedState || !parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    var parsed = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
    var newSection = parsed.querySelector('.shopify-section');
    if (newSection) cartIcon.innerHTML = newSection.innerHTML;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.no-pc-quick');
    if (!btn) return;

    // Evita que el clic burbujee hasta el <a> de la tarjeta y navegue a la ficha del producto.
    evt.preventDefault();
    evt.stopPropagation();

    if (btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Agregando...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          btn.textContent = response.description || 'Sin stock';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.removeAttribute('aria-disabled');
          }, 1800);
          return;
        }

        updateCartIconBubble(response);

        // Confirmación breve en el mismo botón, sin navegar ni abrir nada.
        btn.textContent = '✓ Agregado';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.removeAttribute('aria-disabled');
        }, 1600);
      })
      .catch(function (error) {
        console.error(error);
        btn.textContent = originalText;
        btn.removeAttribute('aria-disabled');
      });
  });
})();
